import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-export-error__container" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-sad-face" }, null, -1);
const _hoisted_3 = { class: "modal-export-error__title" };
const _hoisted_4 = { class: "modal-export-error__subtitle-wrapper" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["href"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-back-arrow" }, null, -1);
import { computed } from 'vue';
import { otoSupportEmail } from '@/utilities/constants';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalExportError',
    props: {
        modelValue: { type: Boolean }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        const isVisible = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value),
        });
        const close = () => {
            emit('update:modelValue', false);
        };
        const supportEmail = otoSupportEmail;
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isVisible).value = $event)),
                id: "audiences-exportation-error",
                class: "modal-export-error",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false,
                width: "500"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('audiences.exportation.error.title')), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", {
                                class: "modal-export-error__subtitle",
                                innerHTML: _ctx.$t('audiences.exportation.error.subtitle')
                            }, null, 8, _hoisted_5),
                            _createElementVNode("a", {
                                class: "modal-export-error__link",
                                href: `mailto:${_unref(supportEmail)}`
                            }, _toDisplayString(_unref(supportEmail)), 9, _hoisted_6)
                        ]),
                        _createElementVNode("button", {
                            class: "btn modal-export-error__btn-back",
                            onClick: close
                        }, [
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
